import React from "react";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination,Autoplay } from "swiper/modules";
import Home_banner from "./home_banner/Home_banner";

function Banner({banner}) {
  return (
    <section className="home-banner-holder">
      <Swiper
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay]}
        className="home_banner_swiper"
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
      >
        {banner?.map((val)=>
        <SwiperSlide>
          <Home_banner val={val}/>
        </SwiperSlide>)}
        
        {/* <SwiperSlide>
          <Home_banner />
        </SwiperSlide>
        <SwiperSlide>
          <Home_banner />
        </SwiperSlide> */}

      </Swiper>
    </section>
  );
}

export default Banner;
